import React from "react";
import Input from "../../../../../Components/Input";
import Loader from "../../../../../Components/Loader";
import EmailConfigurationController from "../../../../Controllers/AdminScreens/Configuration/ConfigurationCenter/EmailConfigurationController";
import LoadingSkeleton from "../../../../../Components/LoadingSkeleton";

const EmailConfigurationScreen = ({ data, loading, error, onRefresh }) => {
    const {
        senderEmail,
        setSenderEmail,
        senderName,
        setSenderName,
        saveLoading,
        saveError,
        success,
        saveEmailConfig,
        senderEmailError,
        setSenderEmailError,
        handleCancel,
    } = EmailConfigurationController(data, loading, error, onRefresh)

    return (
        <div className='basic-info-container' >
            <h3 className="tasksScreen-tasks-title" style={{ paddingBottom: 20, fontFamily: 'Roboto Slab' }}>Email</h3>
            {loading ? (
                <div style={{ display: 'flex', gap: '80px' }}>
                    <div>
                        <label style={styles.label}>{'Sender Email'}</label>
                        <div style={{ marginTop: 10 }}>
                            <LoadingSkeleton width="150%" height="15px" />
                        </div>
                    </div>
                    <div>
                        <label style={styles.label}>{'Sender Name'}</label>
                        <div style={{ marginTop: 10 }}>
                            <LoadingSkeleton width="150%" height="15px" />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="tasksScreen-filters" style={{ display: 'flex' }}>
                    <Input
                        label="Sender Email"
                        placeholder="Enter Sender Email"
                        value={senderEmail}
                        onChange={(e) => { setSenderEmail(e.target.value); setSenderEmailError('') }}
                        errorMessage={senderEmailError}
                        searchBoxWidth={220}
                    />
                    <Input
                        label="Sender Name"
                        placeholder="Enter Sender Name"
                        value={senderName}
                        onChange={(e) => setSenderName(e.target.value)}
                        searchBoxWidth={220}
                    />
                </div>
            )}
            <div className="button-container" style={{ marginTop: '25px' }} >
                {saveError && <div className="list-error-msg" style={{ padding: 0 }}> {saveError}</div>}
                {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}
            </div>
            <div className="button-container" style={{ marginBottom: '30px', }} >
                <button className="add-client-button" style={{ marginRight: '8px', paddingLeft: '30px', paddingRight: '30px', opacity: saveLoading || loading ? 0.5 : 1 }} onClick={saveEmailConfig} disabled={saveLoading || loading}>
                    {(saveLoading || loading) &&
                        <span style={{ paddingRight: 5 }} ><Loader loading={saveLoading || loading} color={'var(--background-color)'} size="small" /> </span>
                    }{data ? "Update" : "Add"}</button>
                <button className="cancel-button" onClick={handleCancel}>Cancel</button>
            </div>
        </div>
    )

}

export default EmailConfigurationScreen;

const styles = {
    label: {
        fontSize: '12px',
        color: '#343C44',
        fontWeight: 400,
        fontFamily: 'Roboto'
    },
};